module.exports = __webpack_public_path__ + "c4e811dc81687327f0eeed4962851f74.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/auth/assets/img/logo.png
 ** module id = 870
 ** module chunks = 0
 **/